var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "turkey",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(0 0.001)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(4.179 9.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M213.472,209.186l1.231,1.7,1.993-.646-1.233,1.694,1.23,1.7-1.992-.649-1.233,1.694v-2.1l-1.992-.649,1.993-.646Z",
    transform: "translate(-203.267 -206.712)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M78.172,176.412a4.239,4.239,0,1,1,2.016-7.968,5.217,5.217,0,1,0,0,7.458A4.218,4.218,0,0,1,78.172,176.412Z",
    transform: "translate(-71.325 -166.956)",
    fill: "#f0f0f0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.d3edf4225a468cad1b0b390e5cc75ec9.svg";
export { ForwardRef as ReactComponent };